import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { getId } from '@fluentui/react';
import { Label } from '@bingads-webui-react/fabric-control';
import { Dropdown } from '@bingads-webui-react/fabric-with-signal';
import { I18nContext } from '@bingads-webui-react/i18n-context';

const localizeText = (i18n, option) => ({
  ...option,
  text: i18n.getString(option.text),
});

export const BidStrategyDropdown = ({
  bidStrategyOptions,
  onBidStrategyChange,
  bidStrategyValue,
  onRenderInlineHelp,
  defaultSelectedKey,
  bidStrategyLabel,
}) => {
  const i18n = useContext(I18nContext);

  const dropdownId = getId('bid-strategy-dropdown');
  const dropdownLabelId = getId('label-dropdown');

  const onRenderLabel = () => (
    <>
      <div className="label-title">
        <Label id={dropdownLabelId}>
          {i18n.getString(bidStrategyLabel)}
        </Label>
        {onRenderInlineHelp && onRenderInlineHelp()}
      </div>
    </>
  );

  const bidOptions = bidStrategyOptions.map(option => localizeText(i18n, option));

  return (
    <Dropdown
      options={bidOptions}
      selectedKey={bidStrategyValue}
      onChange={onBidStrategyChange}
      onRenderLabel={onRenderLabel}
      defaultSelectedKey={defaultSelectedKey}
      className="bid-strategy-dropdown"
      id={dropdownId}
      aria-labelledby={dropdownLabelId}
    />
  );
};

BidStrategyDropdown.propTypes = {
  bidStrategyOptions: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  })).isRequired,
  onBidStrategyChange: PropTypes.func.isRequired,
  bidStrategyValue: PropTypes.string.isRequired,
  onRenderInlineHelp: PropTypes.func,
  defaultSelectedKey: PropTypes.string,
  bidStrategyLabel: PropTypes.string,
};

BidStrategyDropdown.defaultProps = {
  onRenderInlineHelp: null,
  defaultSelectedKey: null,
  bidStrategyLabel: _TL_('Bid Strategy'),
};
